import { PropsWithChildren } from 'react'
import { Box } from '@chakra-ui/react'

export const StyledCartPreview = ({ children }: PropsWithChildren): JSX.Element => {
  return (
    <Box
      display={{ base: 'none', md: 'block' }}
      position="fixed"
      padding="18px"
      width="335px"
      background="white"
      zIndex="sticky"
      top="80px"
      right={{ base: '20px', xl: 'calc((100% - 1320px) / 2)' }}
      border="1px solid {colors.green.a200}"
      borderRadius="{borderRadius.big}"
    >
      {children}
    </Box>
  )
}
